import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SlicePipe } from '@angular/common';
import { BaseRules, TextValues, Control } from './utah.model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import {
  AlertModule,
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule } from '@angular/common';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-utah',
  templateUrl: './utah.component.html',
  styleUrls: ['./utah.component.scss'],
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    CommonModule,
    TruncateModule,
    TooltipModule,
  ],
})
export class UtahComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('utah', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('utah', null);
    }
  }

  hasVisibleDropdowns(type: 'UM' | 'UIM' | 'UMPD'): boolean {
    if (!this.controls || !this.baseRules) {
      return false;
    }

    const dropdownNames: string[] = [];

    if (type === 'UM') {
      dropdownNames.push(
        'UMSplitLimits_DropDown',
        'UMCombinedSingleLimit_DropDown',
        'UMSplitMinLimits_DropDown',
        'UMCombinedSingleMinLimit_DropDown',
      );
    } else if (type === 'UIM') {
      dropdownNames.push(
        'UIMSplitLimits_DropDown',
        'UIMCombinedSingleLimit_DropDown',
        'UIMSplitMinLimits_DropDown',
        'UIMCombinedSingleMinLimit_DropDown',
      );
    } else if (type === 'UMPD') {
      dropdownNames.push('UMPDLimits_DropDown');
    }

    return this.controls.some(
      (control) =>
        dropdownNames.includes(control.formControlName) &&
        this.baseRules[control.baseRuleKey]?.includes('show'),
    );
  }

  override getLookupControlName(control: Control): string | undefined {
    const formControlName = control.formControlName;

    // Determine if it's UIM or UM
    const isUIM =
      formControlName.includes('UIM') && !formControlName.startsWith('UM');
    return isUIM
      ? 'UIMCombinedSingleLimit_DropDown'
      : 'UMCombinedSingleLimit_DropDown';
  }

  override shouldExcludeSplitLimitItem(
    dataItem: any,
    lookupControlName: string,
  ): boolean {
    // Utah: determine if this is a combined limit control
    const isCombinedLimit = lookupControlName.includes('CombinedSingleLimit');

    // Skip split limit format values (with "/") when processing combined limits
    return isCombinedLimit && dataItem?.name?.includes('/');
  }

  override setupHookForDropDownData() {
    this.setupHookForLiabilityDropDownData();
  }
}
